$.fn.countTo = function (options) {

  options = options || {};

  return $(this).each(function () {
     //设置数字背景，需要在页面给需要显示背景的div加个id
        var bjbool = false;
        if($(this)[0].id!=""){
            bjbool = true;
        }
    // set options for current element
    var settings = $.extend({}, $.fn.countTo.defaults, {
      from: $(this).data('from'),
      to: $(this).data('to'),
      speed: $(this).data('speed'),
      refreshInterval: $(this).data('refresh-interval'),
       decimals: $(this).data('decimals'),
            bjbool: bjbool
    }, options);

    // how many times to update the value, and how much to increment the value on each update
    var loops = Math.ceil(settings.speed / settings.refreshInterval),
      increment = (settings.to - settings.from) / loops;

    // references & variables that will change with each update
    var self = this,
      $self = $(this),
      loopCount = 0,
      value = settings.from,
       bj = settings.bjbool,
      data = $self.data('countTo') || {};

    $self.data('countTo', data);

    // if an existing interval can be found, clear it first
    if (data.interval) {
      clearInterval(data.interval);
    }
    data.interval = setInterval(updateTimer, settings.refreshInterval);

    // initialize the element with the starting value
     render(value, bj);

    function updateTimer() {
      value += increment;
      loopCount++;

      render(value, bj);

      if (typeof (settings.onUpdate) == 'function') {
        settings.onUpdate.call(self, value);
      }

      if (loopCount >= loops) {
        // remove the interval
        $self.removeData('countTo');
        clearInterval(data.interval);
        value = settings.to;

        if (typeof (settings.onComplete) == 'function') {
          settings.onComplete.call(self, value);
        }
      }
    }

     function render(value, bj) {
            var formattedValue = settings.formatter.call(self, value, settings);
            var t = "";
            var iindex = 0;
 
            for (var i = formattedValue.length - 1; i >= 0; i--) {
                iindex++;
                if (bj) {//加数字背景
                    t = "<span class=\"spanbj\">" + formattedValue.substr(i, 1) + "</span>" + t;
                }
                else {
                    t = "<span>" + formattedValue.substr(i, 1) + "</span>" + t;
                }
                if (iindex % 3 == 0 && i != 0) {
                    t = "<span>,</span>" + t;
                }
            }

            $self.html(t);
        }
  });
};

$.fn.countTo.defaults = {
  from: 0, // the number the element should start at
  to: 0, // the number the element should end at
  speed: 3000, // how long it should take to count between the target numbers
  refreshInterval: 100, // how often the element should be updated
  decimals: 0, // the number of decimal places to show
  formatter: formatter, // handler for formatting the value before rendering
  onUpdate: null, // callback method for every time the element is updated
  onComplete: null,// callback method for when the element finishes updating
     bjbool: false//是否显示数字背景
};

function formatter(value, settings) {
  return value.toFixed(settings.decimals);
}

export function count(options) {
  var $this = $(this);
  options = $.extend({}, options || {}, $this.data('countToOptions') || {});
  $this.countTo(options);
}
